const NaChat = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="mt-5 mr-10"
    width="17.532"
    height="17.532">
    <path
      fill="none"
      stroke="#191919"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M16.782 11.438a1.781 1.781 0 0 1-1.781 1.781H4.313L.75 16.782V2.531A1.781 1.781 0 0 1 2.531.75h12.47a1.781 1.781 0 0 1 1.781 1.781Z"
      data-name="Icon feather-message-square"
    />
  </svg>
);

export default NaChat;
